import styled from 'styled-components'

export const PopupSpeedAdjustmentButton = styled.span`
    font-size: 19px;
    font-weight: 300;
    padding-right: 1px;
    color: ${p => p.theme.popupForegroundColor};

    ${p => p.theme.utils.flex({})};

    span {
        font-size: 14px;
        margin-top: auto;
        transform: translateY(-2px);
    }
`
